<template>
  <div class="grey lighten-4 text-right pa-4">
    <span class="mx-4">Tổng tiền đã thu</span>
    <span class="red--text mx-4">{{ get(totalFeePaid, 'totalPaidFee') | price }} VNĐ</span>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { get } from 'lodash'
export default {
  computed: {
    ...mapState({
      totalFeePaid: state => state.tuitionFeePeriod.totalFeePaid
    })
  },
  methods: {
    get
  }
}
</script>
<style lang="scss">
.detail_text {
  font-size: 14px;
  color: #0d47a1;
}
</style>
